// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { AiFormAfpFragmentDoc } from '../../../../components/formFields/ai/utils/aiProposalForm.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CreateMaterialImportAiProposalMutationVariables = Types.Exact<{
  input: Types.CreateMaterialImportAiProposalInput;
}>;


export type CreateMaterialImportAiProposalMutation = { __typename?: 'Mutation', createMaterialImportAiProposal: { __typename?: 'MaterialImportAiProposal', id: string, status: { __typename?: 'AiProposalStatusDetail', code: Types.AiProposalStatus } } };

export type MaterialImportAiProposalQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type MaterialImportAiProposalQuery = { __typename?: 'Query', materialImportAiProposal: { __typename?: 'MaterialImportAiProposal', id: string, failureReason?: string | null | undefined, progressText?: string | null | undefined, deletedAt?: Types.Scalars['DateTime']['input'] | null | undefined, manufacturerUrl: string, status: { __typename?: 'AiProposalStatusDetail', code: Types.AiProposalStatus }, item: { __typename?: 'Item', id: string, name: string }, entityProposals: Array<{ __typename?: 'AiEntityProposal', id: string, fieldProposals: Array<{ __typename?: 'AiFieldProposal', id: string, fieldName: string, fieldValue?: string | null | undefined, parentType: Types.AiEntityProposalType, pageNumbers?: Array<number> | null | undefined, status: { __typename?: 'AiFieldProposalStatusDetail', code: Types.AiFieldProposalStatus } }>, entity:
        | { __typename?: 'MaterialListing', id: string }
        | { __typename?: 'MaterialVariant', id: string }
        | { __typename?: 'ReadyPlanLocation' }
        | { __typename?: 'ReadyPlanOption' }
        | { __typename?: 'ReadyPlanProgramData' }
       }> } };


export const CreateMaterialImportAiProposalDocument = gql`
    mutation CreateMaterialImportAiProposal($input: CreateMaterialImportAiProposalInput!) {
  createMaterialImportAiProposal(input: $input) {
    id
    status {
      code
    }
  }
}
    `;

/**
 * __useCreateMaterialImportAiProposalMutation__
 *
 * To run a mutation, you first call `useCreateMaterialImportAiProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMaterialImportAiProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMaterialImportAiProposalMutation, { data, loading, error }] = useCreateMaterialImportAiProposalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMaterialImportAiProposalMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMaterialImportAiProposalMutation, CreateMaterialImportAiProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateMaterialImportAiProposalMutation, CreateMaterialImportAiProposalMutationVariables>(CreateMaterialImportAiProposalDocument, options);
      }
export type CreateMaterialImportAiProposalMutationHookResult = ReturnType<typeof useCreateMaterialImportAiProposalMutation>;
export type CreateMaterialImportAiProposalMutationResult = ApolloReactCommon.MutationResult<CreateMaterialImportAiProposalMutation>;
export const MaterialImportAiProposalDocument = gql`
    query MaterialImportAiProposal($id: ID!) {
  materialImportAiProposal(id: $id) {
    id
    status {
      code
    }
    failureReason
    progressText
    deletedAt
    manufacturerUrl
    item {
      id
      name
    }
    entityProposals(entityType: [MATERIAL_LISTING, MATERIAL_VARIANT]) {
      id
      fieldProposals {
        ...AiFormAfp
      }
      entity {
        ... on MaterialListing {
          id
        }
        ... on MaterialVariant {
          id
        }
      }
    }
  }
}
    ${AiFormAfpFragmentDoc}`;

/**
 * __useMaterialImportAiProposalQuery__
 *
 * To run a query within a React component, call `useMaterialImportAiProposalQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialImportAiProposalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialImportAiProposalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMaterialImportAiProposalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MaterialImportAiProposalQuery, MaterialImportAiProposalQueryVariables> & ({ variables: MaterialImportAiProposalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MaterialImportAiProposalQuery, MaterialImportAiProposalQueryVariables>(MaterialImportAiProposalDocument, options);
      }
export function useMaterialImportAiProposalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MaterialImportAiProposalQuery, MaterialImportAiProposalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MaterialImportAiProposalQuery, MaterialImportAiProposalQueryVariables>(MaterialImportAiProposalDocument, options);
        }
// @ts-ignore
export function useMaterialImportAiProposalSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MaterialImportAiProposalQuery, MaterialImportAiProposalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MaterialImportAiProposalQuery, MaterialImportAiProposalQueryVariables>;
export function useMaterialImportAiProposalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MaterialImportAiProposalQuery, MaterialImportAiProposalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MaterialImportAiProposalQuery | undefined, MaterialImportAiProposalQueryVariables>;
export function useMaterialImportAiProposalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MaterialImportAiProposalQuery, MaterialImportAiProposalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MaterialImportAiProposalQuery, MaterialImportAiProposalQueryVariables>(MaterialImportAiProposalDocument, options);
        }
export type MaterialImportAiProposalQueryHookResult = ReturnType<typeof useMaterialImportAiProposalQuery>;
export type MaterialImportAiProposalLazyQueryHookResult = ReturnType<typeof useMaterialImportAiProposalLazyQuery>;
export type MaterialImportAiProposalSuspenseQueryHookResult = ReturnType<typeof useMaterialImportAiProposalSuspenseQuery>;
export type MaterialImportAiProposalQueryResult = ApolloReactCommon.QueryResult<MaterialImportAiProposalQuery, MaterialImportAiProposalQueryVariables>;